import { render, staticRenderFns } from "./iconDeleteConnection.vue?vue&type=template&id=38a86fe0"
import script from "./iconDeleteConnection.vue?vue&type=script&lang=js"
export * from "./iconDeleteConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports